import React from 'react'
import PropTypes from 'prop-types'

const Confirmation = ({ hidden, ticket }) => {
  const {
    id,
    title,
    description,
    client_name,
    contact_name,
    contact_number
  } = ticket

  if (hidden) {
    return null
  }

  return (
    <div className="flex flex--centered flex--columned text-aligned-center">
      <div className='flex'>
        <span className="lnr lnr-checkmark-circle lnr--green lnr--large" style={{ fontSize: '30px' }} />
        <h2 style={{ fontWeight: '600', margin: 0, marginLeft: '10px' }}>
          {`Ticket #${id} Created.`}
        </h2>
      </div>
      <p>
        Please check your email for a link to your support ticket.
      </p>

      {title && (
        <p style={{ margin: '0' }}>
          {`Title: ${title}`}
        </p>
      )}

      {description && (
        <p style={{ margin: '0' }}>
          {`Description: ${description}`}
        </p>
      )}

      {client_name && (
        <p style={{ margin: '0' }}>
          {`Client name: ${client_name}`}
        </p>
      )}

      {contact_name && (
        <p style={{ margin: '0' }}>
          {`Contact name: ${contact_name}`}
        </p>
      )}

      {contact_number && (
        <p style={{ margin: '0' }}>
          {`Contact number: ${contact_number}`}
        </p>
      )}
    </div>
  )
}

Confirmation.propTypes = {
  hidden: PropTypes.bool
}

Confirmation.defaultProps = {
  hidden: false
}

export default Confirmation
